/*
  vg-cart-guard.js - keeps "host-only" add-ons out of a cart with nothing to fit them to.

  A RAM upgrade, an SSD upgrade or a new battery is a FITTED SERVICE, not a part
  we post on its own: it only makes sense bought alongside the machine it goes
  into. `vg-addon-cart` stamps every add-on line with `_vg_host` = the product id
  of the machine it was ticked on. This guard checks that host is still in the
  cart and pulls the add-on back out if it is not - the customer removed the
  laptop but left the add-on behind, or reached the add-on product page directly.

  Only ids in REQUIRES_HOST are policed. The laptop bag and the warranty are
  deliberately NOT listed - a bag is a fine standalone purchase, and the warranty
  is rendered by its own snippet from `all_products`, not from this field.
  Exception: a warranty added from the cart (`vg-cart-extras`) IS stamped with
  `_vg_host`, so once its own machine leaves the cart it is removed too. Unstamped
  product-page warranties are never touched.

  Loaded site-wide from `snippets/meta-tags.liquid` - see the comment there for
  why it hangs off that snippet instead of layout/theme.liquid.

  A safety net for honest mistakes, not a security boundary: someone can still
  POST to /cart/add by hand. Truly server-side enforcement would need a Shopify
  cart/checkout validation Function, which needs an app deployment.
*/
(function () {
  var REQUIRES_HOST = [
    10383326773530,  // RAM Upgrade (16GB / 32GB)
    10383326839066,  // RAM Upgrade to 16GB
    10383326904602,  // RAM Upgrade to 32GB
    10387166495002,  // New Battery
    10390854533402,  // SSD Upgrade (512GB / 1TB)
    10390854566170,  // SSD Upgrade to 1TB
    10390900703514   // SSD Upgrade (256GB / 512GB / 1TB)
  ];
  var WARRANTY_ID = 10002066964762;  // 2 Year Extended Warranty - policed only when stamped
  var busy = false;

  function hostOf(line) {
    var p = line.properties || {};
    return p._vg_host ? String(p._vg_host) : '';
  }

  function needsHost(line) {
    var id = Number(line.product_id);
    if (REQUIRES_HOST.indexOf(id) !== -1) return true;
    return id === WARRANTY_ID && hostOf(line) !== '';
  }

  function orphanKeys(cart) {
    var items = (cart && cart.items) || [];
    var present = {};
    items.forEach(function (i) { present[String(i.product_id)] = true; });
    return items.filter(function (i) {
      if (!needsHost(i)) return false;
      var host = hostOf(i);
      return !host || !present[host];
    }).map(function (i) { return i.key; });
  }

  function url(key, fallback) {
    return (window.routes && window.routes[key]) ? window.routes[key] + '.js' : fallback;
  }

  function removeKeys(keys) {
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch(url('cart_change_url', '/cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      });
    }, Promise.resolve());
  }

  function flagNotice() {
    try { sessionStorage.setItem('vgCartGuardNotice', '1'); } catch (e) {}
  }

  function showNoticeIfFlagged() {
    var flagged = null;
    try { flagged = sessionStorage.getItem('vgCartGuardNotice'); } catch (e) { return; }
    if (!flagged) return;
    try { sessionStorage.removeItem('vgCartGuardNotice'); } catch (e) {}
    var el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:24px;z-index:99999;max-width:min(560px,92vw);background:#13231a;color:#fff;font:600 14px/1.45 var(--font-body-family,sans-serif);padding:14px 18px;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.25);';
    el.textContent = 'We took an add-on out of your cart - it can only be bought together with a machine we can fit it to.';
    document.body.appendChild(el);
    setTimeout(function () { el.style.transition = 'opacity .4s'; el.style.opacity = '0'; }, 6000);
    setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 6600);
  }

  function sweep() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return fetch(url('cart_url', '/cart.js'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = orphanKeys(cart);
        if (!bad.length) return false;
        return removeKeys(bad).then(function () { flagNotice(); return true; });
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = false; return changed; });
  }

  function sweepThenReload() {
    return sweep().then(function (changed) { if (changed) { window.location.reload(); } return changed; });
  }

  function start() {
    showNoticeIfFlagged();
    sweepThenReload();
  }

  if (document.readyState !== 'loading') { start(); }
  else { document.addEventListener('DOMContentLoaded', start); }

  var origFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var href = (typeof target === 'string') ? target : (target && target.url) || '';
    var out = origFetch.apply(this, arguments);
    if (/\/cart\/(change|update|clear)/.test(href)) {
      out.then(function () { setTimeout(sweepThenReload, 250); }).catch(function () {});
    }
    return out;
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[name="checkout"], .cart__checkout-button') : null;
    if (!btn || busy || btn.dataset.vgChecked === '1') return;
    e.preventDefault();
    sweep().then(function (changed) {
      if (changed) { window.location.reload(); return; }
      btn.dataset.vgChecked = '1';
      var form = btn.closest('form');
      if (form && form.requestSubmit) { form.requestSubmit(btn); }
      else if (form) { form.submit(); }
      else { btn.click(); }
    });
  }, true);
})();
